import { render } from "./RecycleSubResource.vue?vue&type=template&id=c1f42460"
import script from "./RecycleSubResource.vue?vue&type=script&lang=js"
export * from "./RecycleSubResource.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__